import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-model-cash-rules',
  templateUrl: './ll-model-cash-rules.component.html',
  styleUrl: './ll-model-cash-rules.component.css'
})
export class LlModelCashRulesComponent {


  @ViewChild('mainDiv_ll_model_cash_rules') private mainDiv: ElementRef;
  constructor(
    private LlModelsService: LlModelsService,
  ) { }

  bundle = {
    showDisplay: false,
    showGraph: false,
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    LlModelsService: this.LlModelsService,
  }

  ngOnDestroy() { }
  ngOnInit() { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showDisplay = false;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    this.bundle.remainingW = this.bundle.parentW;
    this.bundle.remainingH = this.bundle.parentH;

    setTimeout(() => {
      this.bundle.showDisplay = true;
    });


  }
}
